import { Box } from "@mui/system";
import { useEffect, useState } from "react";
import { usePapaParse } from "react-papaparse";
import { Chart, Axis, Tooltip, Coord, Legend, Interval } from "bizcharts";
import DataSet from "@antv/data-set";
import DownloadButton from "../Common/DownloadButton";

const HorizontalBarChartWIthNegative2 = (props) => {

    const [data, setData] = useState([]);
    const [max, setMax] = useState(20);
    const csv = props.csv;
    const filter = props.filter;
    const { readString } = usePapaParse();
    const [height, setHeight] = useState(500);

    const handleReadString = () => {
        readString(csv, {
            complete: (results, file) => {
                const filtered = results.data.filter(d => d['Food commodity'] === filter);
                setData(filtered);
                setHeight(filtered.length * 40 <= 120 ? 150 : filtered.length * 40);
                let tmpMax = 0;
                filtered.forEach(d => {
                    let exA = Math.abs(d['Difference % above LL 3 years ago']);
                    let exB = Math.abs(d['Difference% quantification 3 years ago']);
                    if (exA > tmpMax) {
                        tmpMax = exA;
                    }
                    if (exB > tmpMax) {
                        tmpMax = exB;
                    }
                });
                setMax(tmpMax + 0.2);
            },
            download: true,
            header: true,
            dynamicTyping: true,
            error: (error, file) => {
                console.log('Error while parsing:', error, file);
            },
        });
    };

    useEffect(() => {
        handleReadString();
    }, [filter]);
    const { DataView } = DataSet;
    const dv = new DataView();
    dv.source(data)
        .transform({
            type: "fold",
            fields: [
                "Difference % above LL 3 years ago",
                "Difference% quantification 3 years ago",
            ],
            key: "opinion",
            value: "value",
        });
    const colorMap = {
        "Difference % above LL 3 years ago": "#00B289",
        "Difference% quantification 3 years ago": "#FFCE3A",
    };

    const [canvas, setCanvas] = useState(undefined);

    const getEmptyStateText = () => {
        return "1 pesticide (" + data[0]['Pesticide'] + ") reported significant decrease in quantification (%) compared to 2017 (" + data[0]['Difference% quantification 3 years ago'] + "%)";
    }
    return (
        <Box>
            {data && data.length > 1 &&
                <Box>
                    <Box display='flex' justifyContent='space-between'>
                        <p style={{ fontFamily: 'Roboto Condensed, sans-serif', marginBottom: '.5rem' }}>{props.title}</p>
                        <DownloadButton canvas={canvas} fileName={props.title} csv={data} isRaw />
                    </Box>

                    <Chart
                        height={height}
                        data={dv}
                        autoFit
                        scale={{
                            value: {
                                min: -(Math.ceil(max / 5) * 5),
                                max: Math.ceil(max / 5) * 5
                            }
                        }}
                        onGetG2Instance={chartInstance => {
                            setCanvas(chartInstance.canvas);
                        }}
                    >
                        <Axis name="Pesticide" title={null} labelOffset={10} />
                        <Axis
                            name="value"
                            label={{
                                formatter: (val) => {
                                    return val + "%";
                                }
                            }}
                            tickLine={null}
                            position="right"

                        />
                        <Coord transpose />
                        <Tooltip shared itemTpl={'<li style="padding: 10px 0" data-index={index}>'
                            + '<span style="background-color:{color};width:8px;height:8px;border-radius:50%;display:inline-block;margin-right:8px;"></span>'
                            + '{name}: {value}%'
                            + '</li>'} />
                        <Legend flipPage={false} />
                        <Interval
                            position="Pesticide*value"
                            color={[
                                "opinion",
                                function (opinion) {
                                    return colorMap[opinion];
                                }
                            ]}
                            shape="smooth"
                            opacity={0.8}
                            adjust={{
                                type: 'dodge'
                            }}
                        />
                    </Chart>
                </Box>
            }
            {
                data &&
                data.length === 0 &&
                <Box display='flex' justifyContent='center'>
                    <p style={{
                        color: 'white',
                        fontWeight: '700',
                        maxWidth: '280px',
                        textAlign: 'center',
                        fontSize: '14px',
                        backgroundColor: '#00B289',
                        padding: '0 10px 0 10px'
                    }}>No significant differences reported for {filter} in all pesticides sampled</p>
                </Box>
            }
            {
                data &&
                data.length === 1 &&
                <Box display='flex' justifyContent='center'>
                    <p style={{
                        color: 'white',
                        fontWeight: '700',
                        maxWidth: '280px',
                        textAlign: 'center',
                        fontSize: '14px',
                        backgroundColor: '#00B289',
                        padding: '0 10px 0 10px'
                    }}>{getEmptyStateText()}</p>
                </Box>
            }
        </Box>
    );
}

export default HorizontalBarChartWIthNegative2;